<template>
  <div>
    <BaseHeader>
      <template v-slot:title>My Profile</template>
    </BaseHeader>

    <b-container class="py-5 my-5">
      <validation-observer v-slot="{ invalid }" ref="form">
        <b-form
          v-loading="formProcessing"
          @submit.prevent="submitForm"
          class="form form-lg mx-auto"
        >
          <b-row>
            <b-col md="5">
              <BaseAvatar
                :src="currentUser.profile_photo"
                :editable="false"
                initials-only
              />
            </b-col>
            <b-col>
              <base-input
                v-model="currentUser.first_name"
                name="Name"
                label="Name"
              ></base-input>

              <base-input
                v-model="currentUser.email"
                rules="required|email"
                name="Email Address"
                label="Email Address"
                readonly
              ></base-input>

              <base-select
                v-model="selectedReport"
                @input="setDefaultReport"
                :options="reportOptions"
                name="Default Report"
                label="Default Report"
                placeholder="Select Default Report"
              ></base-select>

              <div class="mt-4 d-flex justify-content-between">
                <router-link
                  :to="{ name: 'Dashboard' }"
                  class="btn btn-md border-primary d-inline-flex align-items-center shadow-none"
                  >Cancel</router-link
                >
                <base-button
                  :disabled="invalid"
                  type="primary"
                  native-type="submit"
                  size="md"
                  class="font-weight-normal"
                  >Save Changes</base-button
                >
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import { orderBy } from 'lodash-es'
import { userMixin } from '@mixins'
import { ProfileService, ReportsService } from '@services'

import { BaseHeader } from '@/components/base'
import BaseAvatar from '@components/BaseAvatar'

export default {
  title() {
    return this.currentUser.first_name || ''
  },
  components: {
    BaseHeader,
    BaseAvatar
  },
  data() {
    return {
      formProcessing: false,
      selectedReport: null,
      reportOptions: []
    }
  },
  mixins: [userMixin],
  watch: {
    reportOptions: {
      handler: function (val) {
        const index = val.findIndex(
          (item) => item.report_id === this.currentUser.report_id
        )

        if (0 <= index) this.selectedReport = val[index].value
      }
    }
  },
  methods: {
    async fetchReports() {
      const response = await ReportsService.list(null, false)
      const sort = (item) =>
        item.display_name
          ? item.display_name.toLowerCase()
          : item.name.toLowerCase()

      this.reportOptions = orderBy(
        response.data.data.data,
        ['is_favorite', sort],
        ['desc', 'asc']
      ).map((item) => {
        let reportTitle = this.currentUser.is_superuser
          ? item.name
          : item.display_name || item.name
        reportTitle += `${item.is_favorite ? '*' : ''}`

        return {
          value: item.id,
          text: reportTitle,
          report_id: item.report_id || item.id
        }
      })
    },
    async submitForm() {
      this.formProcessing = true

      await ProfileService.update(ProfileService.user)

      this.formProcessing = false

      this.$toasted.show('Profile successfully updated.')

      this.$router.push({ name: 'Dashboard' })
    },
    async setDefaultReport(value) {
      if (!value) return false

      this.formProcessing = true

      await ProfileService.setDefaultReport({
        default_report: value
      })

      this.formProcessing = false

      this.$toasted.show('Default report updated')
    }
  },
  mounted() {
    this.fetchReports()
  }
}
</script>
